import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class WorkflowExecutionLinkDTO extends DataTransferObject {
    public PDWorkflowMetaPDO_ID: any;
    public StartAction: any;
    public StartActionName: any;
    public Path: any;
    public IsNavigationTreeRelevant: any;
    public IsMenuRelevant: any;
    public GuiLabelMLS: any;
    public ShortDescriptionMLS: any;
    public IconUrl: any;
    public Name: any;

    constructor() {
        super({
            xmlProperties: [
                'PDWorkflowMetaPDO_ID',
                'StartAction',
                'StartActionName',
                'Path',
                'IsNavigationTreeRelevant',
                'IsMenuRelevant',
                'GuiLabelMLS',
                'ShortDescriptionMLS',
                'IconUrl',
                'Name'
            ],
            xmlNamespace: 'WorkflowEngine'
        });
        this.PDWorkflowMetaPDO_ID = this.defaultFromType('long');
        this.StartAction = this.defaultFromType('string');
        this.StartActionName = this.defaultFromType('string');
        this.Path = this.defaultFromType('string');
        this.IsNavigationTreeRelevant = this.defaultFromType('bool');
        this.IsMenuRelevant = this.defaultFromType('bool');
        this.GuiLabelMLS = this.defaultFromType('string');
        this.ShortDescriptionMLS = this.defaultFromType('string');
        this.IconUrl = this.defaultFromType('string');
        this.Name = this.defaultFromType('string');
    }
}

ComponentManager.setModel('WorkflowExecutionLinkDTO', WorkflowExecutionLinkDTO, 'WorkflowEngineHTMLViewExtension');